import { useState, useRef, useLayoutEffect } from "react";

export const useBoundingRect = () => {
  const [boundingRect, setBoundingRect] = useState(null);
  const ref = useRef();

  useLayoutEffect(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setBoundingRect(rect);
    }
  }, []);

  return {
    ref,
    boundingRect
  };
};
